module.exports = __webpack_public_path__ + "static/img/anxun32.d0e05a85.png";